import React, { Component } from "react";
import PropTypes from "prop-types";
import reactCSS from "reactcss";
import ReactTable from "react-table";
import {
  IntlProvider,
  FormattedDate,
  FormattedTime,
  addLocaleData
} from "react-intl";
import ptBr from "react-intl/locale-data/pt";
import StyledButton from "../styled-button";
import moment from "moment";
import { CurrencyValue } from "components/support";
import "react-table/react-table.css";
import styles from "./styles";

addLocaleData([...ptBr]);

const i18nData = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      }
    }
  }
};

class DataTable extends Component {
  static propTypes = {
    resultSet: PropTypes.any,
    total: PropTypes.any,
    perPage: PropTypes.any,
    page: PropTypes.any,
    config: PropTypes.any,
    onChange: PropTypes.any,
    orderField: PropTypes.any,
    orderDirection: PropTypes.any,
    onPageChange: PropTypes.any,
    onFilteredChange: PropTypes.any,
    onClickRow: PropTypes.any,
    filterable: PropTypes.bool,
    manual: PropTypes.bool,
    ignoreLinkFields: PropTypes.any,
    linkRow: PropTypes.bool
  };

  static defaultProps = {
    resultSet: [],
    defaultSorted: [],
    pages: -1,
    total: 0,
    perPage: 10,
    page: 1,
    config: {},
    orderField: "",
    orderDirection: "",
    filterable: false,
    manual: false,
    loading: false,
    showPagination: true,
    ignoreLinkFields: [],
    linkRow: false,
    onFetchData: () => {},
    onChange: () => {},
    onPageChange: () => {},
    onFilteredChange: () => {},
    onClickRow: () => {}
  };

  getPageCount = () => {
    const pageCount = Math.ceil(
      Math.max(this.props.total, 1) / Math.max(this.props.perPage, 1)
    );
    return this.props.perPage === 0 ? 0 : pageCount;
  };

  handleSortedChange = sorted => {
    if (!this.props.onChange) {
      return;
    }

    sorted.forEach(sort => {
      const field = sort.id;
      const value = sort.desc ? "DESC" : "ASC";

      this.props.onChange({
        field,
        value
      });
    });
  };

  rawFormat = (value, type) => {
    let valueFormatted = "";

    switch (type) {
      case "date":
        valueFormatted = new moment(value).utc();
        return !!value && valueFormatted.isValid() ? (
          <FormattedDate value={valueFormatted} />
        ) : (
          "-"
        );
      case "time":
        return <FormattedTime value={value} />;
      case "datetime":
        valueFormatted = new moment(value).utc();
        return !!value && valueFormatted.isValid() ? (
          <span>
            <FormattedDate value={value} /> <FormattedTime value={value} />
          </span>
        ) : (
          "-"
        );

      case "money":
        return <CurrencyValue value={value} type="money" />;

      case "int":
        return parseInt(value, 10);

      default:
        return value || "-";
    }
  };

  getFormatted = (result, column) => {
    switch (column.type) {
      case "subfield":
        return this.rawFormat(
          column.params.subfield(result),
          column.params.type
        );
      case "enum":
        return column.params.enum[result.value];
      case "custom":
        return column.params.format(result);
      default:
        return this.rawFormat(result.value, column.type);
    }
  };

  getColumnsFormatted = columns => {
    return columns.map(v => {
      if (v.type && !v.Cell) {
        v.Cell = row => {
          return this.getFormatted(row, v);
        };
        return v;
      }
      return v;
    });
  };

  render() {
    const { className } = this.props;
    const styles = reactCSS({
      default: {
        field: {
          width: "100%",
          overflow: "hidden",
          fontFamily: "Source Sans Pro"
        }
      }
    });
    const data = this.props.resultSet;
    const columns = this.getColumnsFormatted(this.props.config.columns);
    const pagination = !!this.props.manual
      ? {
          page: this.props.page - 1,
          pages: this.getPageCount()
        }
      : {};

    return (
      <div className={className}>
        <div className="data-table" style={styles.field}>
          <IntlProvider {...i18nData}>
            <ReactTable
              minRows={data.length > 0 ? 0 : 4}
              PreviousComponent={props => {
                return <StyledButton flat {...props} />;
              }}
              getTdProps={(state, rowInfo, column, instance) => ({
                onClick: e => {
                  if (!this.props.ignoreLinkFields.includes(column.id)) {
                    this.props.onClickRow(rowInfo.original.uuid);
                  }
                },
                style: {
                  textAlign: !!column.align ? column.align : "left",
                  cursor:
                    !this.props.ignoreLinkFields.includes(column.id) &&
                    this.props.linkRow
                      ? "pointer"
                      : "normal"
                }
              })}
              NextComponent={props => {
                return <StyledButton flat {...props} />;
              }}
              defaultPageSize={this.props.perPage}
              columns={columns}
              previousText="Anterior"
              nextText="Próximo"
              loadingText="Carregando..."
              noDataText="Nenhum dado encontrado"
              pageText="Página"
              ofText="de"
              rowsText="linhas"
              showPageSizeOptions={false}
              filterable={this.props.filterable}
              manual={this.props.manual}
              data={data}
              {...pagination}
              loading={this.props.loading}
              onPageChange={page => this.props.onPageChange(page)}
              onFilteredChange={filtered =>
                this.props.onFilteredChange(filtered)
              }
              onSortedChange={sorted => this.handleSortedChange(sorted)}
              defaultSorted={this.props.defaultSorted}
              showPaginationBottom={this.props.showPagination}
            />
          </IntlProvider>
        </div>
      </div>
    );
  }
}

export default styles(DataTable);



// WEBPACK FOOTER //
// ./src/components/support/data-table/index.jsx